/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v1.48.4 of "Products"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { ColorId } from '../models/ColorId';
import type { CustomizationUpdate } from '../models/CustomizationUpdate';
import type { Favorite } from '../models/Favorite';
import type { GetCustomizationResponse } from '../models/GetCustomizationResponse';
import type { GetImageResponse } from '../models/GetImageResponse';
import type { HiddenOnOverview } from '../models/HiddenOnOverview';
import type { LabelsUpdate } from '../models/LabelsUpdate';
import type { Name } from '../models/Name';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class CustomizationService {

    /**
     * Customization details of a product
     * Get customization details for a given product.
     *
     * @returns GetCustomizationResponse Returns customization details of a product
     * @throws ApiError
     */
    public static getPublicProductsCustomization({
        id,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicProductsCustomization({
        id,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetCustomizationResponse>;
    public static getPublicProductsCustomization({
        id
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/products/{id}/customization',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Update customization of a product
     * Update the customization.
     * If a property is set to `null` it will be reset to default (see [Customization Defaults](#section/Customization-Defaults) for details).
     *
     * @returns GetCustomizationResponse Returns customization details of a product
     * @throws ApiError
     */
    public static putPublicProductsCustomization({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: CustomizationUpdate
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putPublicProductsCustomization({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: CustomizationUpdate
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetCustomizationResponse>;
    public static putPublicProductsCustomization({
        id,
        requestBody
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: CustomizationUpdate,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/products/{id}/customization',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Indicates that user is not authorized to update the specified resource.`,
            },
        });
    }

    /**
     * Update product name
     * Update the customizable product name. Only available for users with required permissions.
     * If a property is set to `null` it will be reset to default (see [Customization Defaults](#section/Customization-Defaults) for details).
     *
     * @returns GetCustomizationResponse Returns customization details of a product
     * @throws ApiError
     */
    public static putPublicProductsCustomizationName({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            name: Name;
        }
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putPublicProductsCustomizationName({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            name: Name;
        }
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetCustomizationResponse>;
    public static putPublicProductsCustomizationName({
        id,
        requestBody
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            name: Name;
        },
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/products/{id}/customization/name',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Indicates that user is not authorized to update the specified resource.`,
            },
        });
    }

    /**
     * Update product color
     * Update product color.
     * If a property is set to `null` it will be reset to default (see [Customization Defaults](#section/Customization-Defaults) for details).
     *
     * @returns GetCustomizationResponse Returns customization details of a product
     * @throws ApiError
     */
    public static putPublicProductsCustomizationColor({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            color: ColorId;
        }
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putPublicProductsCustomizationColor({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            color: ColorId;
        }
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetCustomizationResponse>;
    public static putPublicProductsCustomizationColor({
        id,
        requestBody
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            color: ColorId;
        },
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/products/{id}/customization/color',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update product labels
     * Update product labels.
     *
     * @returns GetCustomizationResponse Returns customization details of a product
     * @throws ApiError
     */
    public static putPublicProductsCustomizationLabels({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            labels: LabelsUpdate;
        }
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putPublicProductsCustomizationLabels({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            labels: LabelsUpdate;
        }
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetCustomizationResponse>;
    public static putPublicProductsCustomizationLabels({
        id,
        requestBody
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            labels: LabelsUpdate;
        },
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/products/{id}/customization/labels',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Mark/unmark product as favorite.
     * Update product favorite flag.
     *
     * @returns GetCustomizationResponse Returns customization details of a product
     * @throws ApiError
     */
    public static putPublicProductsCustomizationFavorite({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            favorite: Favorite;
        }
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putPublicProductsCustomizationFavorite({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            favorite: Favorite;
        }
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetCustomizationResponse>;
    public static putPublicProductsCustomizationFavorite({
        id,
        requestBody
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            favorite: Favorite;
        },
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/products/{id}/customization/favorite',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Mark/unmark a product as hidden on the overview.
     * Update product hiddenOnOverview flag.
     *
     * @returns GetCustomizationResponse Returns customization details of a product
     * @throws ApiError
     */
    public static putPublicProductsCustomizationHiddenOnOverview({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            hiddenOnOverview: HiddenOnOverview;
        }
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putPublicProductsCustomizationHiddenOnOverview({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            hiddenOnOverview: HiddenOnOverview;
        }
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetCustomizationResponse>;
    public static putPublicProductsCustomizationHiddenOnOverview({
        id,
        requestBody
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            hiddenOnOverview: HiddenOnOverview;
        },
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/products/{id}/customization/hidden-on-overview',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update position of a product
     * Update position in customization details for a given product.
     *
     * @returns void
     * @throws ApiError
     */
    public static putPublicProductsCustomizationPosition({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            /**
             * The positional relation to the given `productId`.
             */
            relation: 'DIRECTLY_BEFORE' | 'DIRECTLY_AFTER';
            /**
             * The id of the product in which relation we are positioning.
             */
            productId: string;
        }
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putPublicProductsCustomizationPosition({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            /**
             * The positional relation to the given `productId`.
             */
            relation: 'DIRECTLY_BEFORE' | 'DIRECTLY_AFTER';
            /**
             * The id of the product in which relation we are positioning.
             */
            productId: string;
        }
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<void>;
    public static putPublicProductsCustomizationPosition({
        id,
        requestBody
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        requestBody?: {
            /**
             * The positional relation to the given `productId`.
             */
            relation: 'DIRECTLY_BEFORE' | 'DIRECTLY_AFTER';
            /**
             * The id of the product in which relation we are positioning.
             */
            productId: string;
        },
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/products/{id}/customization/position',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Product image
     * Get the image of a product, either the original or a variant.
     *
     * @returns GetImageResponse Returns binary product image
     * @throws ApiError
     */
    public static getPublicProductsCustomizationImage({
        id,
        variant,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        /**
         * Resolution variant of the image.
         * If not provided or not found the original image will be returned.
         *
         */
        variant?: 'ORIGINAL' | 'MOBILE' | 'V250x250'
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicProductsCustomizationImage({
        id,
        variant,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        /**
         * Resolution variant of the image.
         * If not provided or not found the original image will be returned.
         *
         */
        variant?: 'ORIGINAL' | 'MOBILE' | 'V250x250'
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetImageResponse>;
    public static getPublicProductsCustomizationImage({
        id,
        variant
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        /**
         * Resolution variant of the image.
         * If not provided or not found the original image will be returned.
         *
         */
        variant?: 'ORIGINAL' | 'MOBILE' | 'V250x250',
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/products/{id}/customization/image',
            path: {
                'id': id,
            },
            query: {
                'variant': variant,
            },
            headers: {
                'accept': 'application/octet-stream',
            },
            errors: {
                404: `Not Found`,
                502: `Bad Gateway`,
            },
        });
    }

    /**
     * Upload product image
     * Set image of the product.
     *
     * @returns any Image was successfully uploaded
     * @throws ApiError
     */
    public static postPublicProductsCustomizationImage({
        id,
        formData,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        formData?: {
            /**
             * Original image to be assigned as product image.
             *
             * | Requirements  | Description                                          |
             * |---------------|------------------------------------------------------|
             * | FileSizeLimit | 5 Megabyte                                           |
             * | MimeTypes     | `image/gif`, `image/png`, `image/jpeg`, `image/webp` |
             * | AspectRatio   | 1:1                                                  |
             *
             */
            file?: Blob;
        }
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postPublicProductsCustomizationImage({
        id,
        formData,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        formData?: {
            /**
             * Original image to be assigned as product image.
             *
             * | Requirements  | Description                                          |
             * |---------------|------------------------------------------------------|
             * | FileSizeLimit | 5 Megabyte                                           |
             * | MimeTypes     | `image/gif`, `image/png`, `image/jpeg`, `image/webp` |
             * | AspectRatio   | 1:1                                                  |
             *
             */
            file?: Blob;
        }
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<any>;
    public static postPublicProductsCustomizationImage({
        id,
        formData
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
        formData?: {
            /**
             * Original image to be assigned as product image.
             *
             * | Requirements  | Description                                          |
             * |---------------|------------------------------------------------------|
             * | FileSizeLimit | 5 Megabyte                                           |
             * | MimeTypes     | `image/gif`, `image/png`, `image/jpeg`, `image/webp` |
             * | AspectRatio   | 1:1                                                  |
             *
             */
            file?: Blob;
        },
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/products/{id}/customization/image',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                415: `Unsupported Media Type`,
            },
        });
    }

    /**
     * Delete product image
     * Delete the image of the product.
     *
     * @returns void
     * @throws ApiError
     */
    public static deletePublicProductsCustomizationImage({
        id,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static deletePublicProductsCustomizationImage({
        id,
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<void>;
    public static deletePublicProductsCustomizationImage({
        id
    }: {
        /**
         * The `id` of the product, as delivered by the host system (`hostId`)
         */
        id: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'DELETE',
            url: '/public/products/{id}/customization/image',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

}
